import React, {useEffect, useMemo, useState} from 'react';
import { useTranslation } from 'react-i18next';
import ColumnChart from "../../charts/ColumnChart";
import BlockChart from "../../BlockChart";

const ConsentByLangChart = ( {data=[], isSuccess, isFetching: isLoading, refetch} ) => {
  const { t } = useTranslation();
  const formatData = (data) => {
    return {
      categories: data.map((elt) => (t(elt.language_code))),
      series: [
        {
          name: 'consent',
          data: data.map((elt) => ( elt.count ? 100 * elt.accepted_count / elt.count : 0 ) )
        }
      ]
    }
  }
  const formattedData = useMemo(() => formatData(data), [data])

  return (
    <BlockChart title={t("cmp.analytics.consentsByLang")} isLoading={isLoading} isSuccess={isSuccess}>
      <ColumnChart data={formattedData} legendOptions={{show: false}}/>
    </BlockChart>
  )
}

export default ConsentByLangChart
